import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MapPin, Briefcase, Users, ChevronRight, ArrowRight } from "lucide-react";
import { Badge } from "@/Components/ui/badge";

const RecentJobs = ({ jobs, setActiveMain }) => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const companyID = new URLSearchParams(location.search).get("companyID");

  const handleJobClick = (jobId) => {
    navigate(`/all-candidates?companyID=${encodeURIComponent(companyID)}&jobID=${encodeURIComponent(jobId)}`);
  };

  const handleViewAll = () => {
    navigate(`/all-jobs?companyID=${encodeURIComponent(companyID)}`);
  };

  if (!jobs || jobs.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-8 text-center">
        <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center mb-3">
          <Briefcase className="w-5 h-5 text-slate-400" />
        </div>
        <p className="text-sm text-slate-500">No jobs posted yet</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1">
      <p className="text-xs text-slate-400 font-medium mb-2">
        {jobs.length} job{jobs.length !== 1 ? "s" : ""} published
      </p>

      {jobs.slice(0, 4).map((job) => (
        <button
          key={job.job_id}
          onClick={() => handleJobClick(job.job_id)}
          className="w-full text-left flex items-start gap-3 p-3 rounded-xl border border-slate-100 hover:border-indigo-200 hover:bg-indigo-50/40 transition-all duration-150 cursor-pointer bg-white group"
        >
          {/* Job icon */}
          <div className="w-8 h-8 rounded-lg bg-indigo-50 flex items-center justify-center shrink-0 mt-0.5 group-hover:bg-indigo-100 transition-colors">
            <Briefcase className="w-4 h-4 text-indigo-500" />
          </div>

          {/* Job info */}
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-slate-800 truncate leading-snug">
              {job.job_title}
            </p>
            <div className="flex items-center gap-2 mt-1 flex-wrap">
              {job.location && (
                <span className="flex items-center gap-0.5 text-xs text-slate-400">
                  <MapPin className="w-3 h-3" />
                  {job.location}
                </span>
              )}
              {job.experience_range && (
                <Badge variant="secondary" className="text-[10px] px-1.5 py-0 h-4 font-normal">
                  {job.experience_range}
                </Badge>
              )}
            </div>
            {job.applicants > 0 && (
              <div className="flex items-center gap-1 mt-1">
                <Users className="w-3 h-3 text-slate-400" />
                <span className="text-[11px] text-slate-400">{job.applicants} applicant{job.applicants !== 1 ? "s" : ""}</span>
              </div>
            )}
          </div>

          <ChevronRight className="w-4 h-4 text-slate-300 group-hover:text-indigo-400 shrink-0 mt-1 transition-colors" />
        </button>
      ))}

      {jobs.length > 0 && (
        <button
          onClick={handleViewAll}
          className="mt-2 w-full flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-medium text-indigo-600 hover:bg-indigo-50 transition-colors border-none bg-transparent cursor-pointer"
        >
          View all jobs
          <ArrowRight className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
};

export default RecentJobs;
